// extracted by mini-css-extract-plugin
export default {"block":"SnakeBlock_block__v7zaE","description":"SnakeBlock_description__cMg3i","title":"SnakeBlock_title__jGono","text":"SnakeBlock_text__t9SsD","app":"SnakeBlock_app__DIdp0"};